[
  {
    "level": 1,
    "reward_points": 0,
    "energy_max_multiplier": 1
  },
  {
    "level": 2,
    "xp": 8,
    "reward_points": 1000,
    "energy_max_multiplier": 1
  },
  {
    "level": 3,
    "xp": 16,
    "reward_points": 1000,
    "energy_max_multiplier": 1
  },
  {
    "level": 4,
    "xp": 32,
    "reward_points": 1000,
    "energy_max_multiplier": 2
  },
  {
    "level": 5,
    "xp": 50,
    "reward_points": 1000,
    "energy_max_multiplier": 2
  },
  {
    "level": 6,
    "xp": 64,
    "reward_points": 1000,
    "energy_max_multiplier": 2
  },
  {
    "level": 7,
    "xp": 65,
    "reward_points": 1000,
    "energy_max_multiplier": 3
  },
  {
    "level": 8,
    "xp": 66,
    "reward_points": 1000,
    "energy_max_multiplier": 3
  },
  {
    "level": 9,
    "xp": 67,
    "reward_points": 1000,
    "energy_max_multiplier": 3
  },
  {
    "level": 10,
    "xp": 68,
    "reward_points": 1000,
    "energy_max_multiplier": 5
  },
  {
    "level": 11,
    "xp": 70,
    "reward_points": 1000,
    "energy_max_multiplier": 5
  },
  {
    "level": 12,
    "xp": 72,
    "reward_points": 1000,
    "energy_max_multiplier": 5
  },
  {
    "level": 13,
    "xp": 74,
    "reward_points": 1000,
    "energy_max_multiplier": 10
  },
  {
    "level": 14,
    "xp": 76,
    "reward_points": 1000,
    "energy_max_multiplier": 10
  },
  {
    "level": 15,
    "xp": 78,
    "reward_points": 1000,
    "energy_max_multiplier": 10
  },
  {
    "level": 16,
    "xp": 80,
    "reward_points": 1000,
    "energy_max_multiplier": 20
  },
  {
    "level": 17,
    "xp": 82,
    "reward_points": 1000,
    "energy_max_multiplier": 20
  },
  {
    "level": 18,
    "xp": 84,
    "reward_points": 1000,
    "energy_max_multiplier": 20
  },
  {
    "level": 19,
    "xp": 86,
    "reward_points": 1000,
    "energy_max_multiplier": 30
  },
  {
    "level": 20,
    "xp": 88,
    "reward_points": 1000,
    "energy_max_multiplier": 30
  },
  {
    "level": 21,
    "xp": 89,
    "reward_points": 1000,
    "energy_max_multiplier": 30
  },
  {
    "level": 22,
    "xp": 90,
    "reward_points": 1000,
    "energy_max_multiplier": 50
  },
  {
    "level": 23,
    "xp": 91,
    "reward_points": 1000,
    "energy_max_multiplier": 50
  },
  {
    "level": 24,
    "xp": 92,
    "reward_points": 1000,
    "energy_max_multiplier": 50
  },
  {
    "level": 25,
    "xp": 93,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 26,
    "xp": 94,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 27,
    "xp": 95,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 28,
    "xp": 96,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 29,
    "xp": 97,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 30,
    "xp": 98,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 31,
    "xp": 99,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 32,
    "xp": 100,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 33,
    "xp": 101,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 34,
    "xp": 102,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 35,
    "xp": 103,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 36,
    "xp": 104,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 37,
    "xp": 105,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 38,
    "xp": 106,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 39,
    "xp": 107,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 40,
    "xp": 108,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 41,
    "xp": 109,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 42,
    "xp": 110,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 43,
    "xp": 111,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 44,
    "xp": 112,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 45,
    "xp": 113,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 46,
    "xp": 114,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 47,
    "xp": 115,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 48,
    "xp": 116,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 49,
    "xp": 117,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 50,
    "xp": 118,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 51,
    "xp": 119,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 52,
    "xp": 120,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 53,
    "xp": 121,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 54,
    "xp": 122,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 55,
    "xp": 123,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 56,
    "xp": 124,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 57,
    "xp": 125,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 58,
    "xp": 126,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 59,
    "xp": 127,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 60,
    "xp": 128,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 61,
    "xp": 129,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 62,
    "xp": 130,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 63,
    "xp": 131,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 64,
    "xp": 132,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 65,
    "xp": 133,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 66,
    "xp": 134,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 67,
    "xp": 135,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 68,
    "xp": 136,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 69,
    "xp": 137,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 70,
    "xp": 138,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 71,
    "xp": 139,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 72,
    "xp": 140,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 73,
    "xp": 141,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 74,
    "xp": 142,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 75,
    "xp": 143,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 76,
    "xp": 144,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 77,
    "xp": 145,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 78,
    "xp": 146,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 79,
    "xp": 147,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 80,
    "xp": 148,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 81,
    "xp": 149,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 82,
    "xp": 150,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 83,
    "xp": 151,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 84,
    "xp": 152,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 85,
    "xp": 153,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 86,
    "xp": 154,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 87,
    "xp": 155,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 88,
    "xp": 156,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 89,
    "xp": 157,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 90,
    "xp": 158,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 91,
    "xp": 159,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 92,
    "xp": 160,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 93,
    "xp": 161,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 94,
    "xp": 162,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 95,
    "xp": 163,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 96,
    "xp": 164,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 97,
    "xp": 165,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 98,
    "xp": 166,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 99,
    "xp": 167,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 100,
    "xp": 172,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 101,
    "xp": 177,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 102,
    "xp": 182,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 103,
    "xp": 187,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 104,
    "xp": 192,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 105,
    "xp": 197,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 106,
    "xp": 202,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 107,
    "xp": 207,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 108,
    "xp": 212,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 109,
    "xp": 217,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 110,
    "xp": 222,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 111,
    "xp": 227,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 112,
    "xp": 232,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 113,
    "xp": 237,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 114,
    "xp": 242,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 115,
    "xp": 247,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 116,
    "xp": 252,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 117,
    "xp": 257,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 118,
    "xp": 262,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 119,
    "xp": 267,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 120,
    "xp": 272,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 121,
    "xp": 277,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 122,
    "xp": 282,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 123,
    "xp": 287,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 124,
    "xp": 292,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 125,
    "xp": 297,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 126,
    "xp": 302,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 127,
    "xp": 307,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 128,
    "xp": 312,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 129,
    "xp": 317,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 130,
    "xp": 322,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 131,
    "xp": 327,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 132,
    "xp": 332,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 133,
    "xp": 337,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 134,
    "xp": 342,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 135,
    "xp": 347,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 136,
    "xp": 352,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 137,
    "xp": 357,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 138,
    "xp": 362,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 139,
    "xp": 367,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 140,
    "xp": 372,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 141,
    "xp": 377,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 142,
    "xp": 382,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 143,
    "xp": 387,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 144,
    "xp": 392,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 145,
    "xp": 397,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 146,
    "xp": 402,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 147,
    "xp": 407,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 148,
    "xp": 412,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 149,
    "xp": 417,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 150,
    "xp": 422,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 151,
    "xp": 427,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 152,
    "xp": 432,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 153,
    "xp": 437,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 154,
    "xp": 442,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 155,
    "xp": 447,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 156,
    "xp": 452,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 157,
    "xp": 457,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 158,
    "xp": 462,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 159,
    "xp": 467,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 160,
    "xp": 472,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 161,
    "xp": 477,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 162,
    "xp": 482,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 163,
    "xp": 487,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 164,
    "xp": 492,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 165,
    "xp": 497,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 166,
    "xp": 502,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 167,
    "xp": 507,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 168,
    "xp": 512,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 169,
    "xp": 517,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 170,
    "xp": 522,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 171,
    "xp": 527,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 172,
    "xp": 532,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 173,
    "xp": 537,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 174,
    "xp": 542,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 175,
    "xp": 547,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 176,
    "xp": 552,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 177,
    "xp": 557,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 178,
    "xp": 562,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 179,
    "xp": 567,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 180,
    "xp": 572,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 181,
    "xp": 577,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 182,
    "xp": 582,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 183,
    "xp": 587,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 184,
    "xp": 592,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 185,
    "xp": 597,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 186,
    "xp": 602,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 187,
    "xp": 607,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 188,
    "xp": 612,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 189,
    "xp": 617,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 190,
    "xp": 622,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 191,
    "xp": 627,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 192,
    "xp": 632,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 193,
    "xp": 637,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 194,
    "xp": 642,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 195,
    "xp": 647,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 196,
    "xp": 652,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 197,
    "xp": 657,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 198,
    "xp": 662,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 199,
    "xp": 667,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 200,
    "xp": 672,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 201,
    "xp": 677,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 202,
    "xp": 682,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 203,
    "xp": 687,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 204,
    "xp": 692,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 205,
    "xp": 697,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 206,
    "xp": 702,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 207,
    "xp": 707,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 208,
    "xp": 712,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 209,
    "xp": 717,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 210,
    "xp": 722,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 211,
    "xp": 727,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 212,
    "xp": 732,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 213,
    "xp": 737,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 214,
    "xp": 742,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 215,
    "xp": 747,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 216,
    "xp": 752,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 217,
    "xp": 757,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 218,
    "xp": 762,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 219,
    "xp": 767,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 220,
    "xp": 772,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 221,
    "xp": 777,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 222,
    "xp": 782,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 223,
    "xp": 787,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 224,
    "xp": 792,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 225,
    "xp": 797,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 226,
    "xp": 802,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 227,
    "xp": 807,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 228,
    "xp": 812,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 229,
    "xp": 817,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 230,
    "xp": 822,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 231,
    "xp": 827,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 232,
    "xp": 832,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 233,
    "xp": 837,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 234,
    "xp": 842,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 235,
    "xp": 847,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 236,
    "xp": 852,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 237,
    "xp": 857,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 238,
    "xp": 862,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 239,
    "xp": 867,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 240,
    "xp": 872,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 241,
    "xp": 877,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 242,
    "xp": 882,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 243,
    "xp": 887,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 244,
    "xp": 892,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 245,
    "xp": 897,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 246,
    "xp": 902,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 247,
    "xp": 907,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 248,
    "xp": 912,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 249,
    "xp": 917,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 250,
    "xp": 922,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 251,
    "xp": 927,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 252,
    "xp": 932,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 253,
    "xp": 937,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 254,
    "xp": 942,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 255,
    "xp": 947,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 256,
    "xp": 952,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 257,
    "xp": 957,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 258,
    "xp": 962,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 259,
    "xp": 967,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 260,
    "xp": 972,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 261,
    "xp": 977,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 262,
    "xp": 982,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 263,
    "xp": 987,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 264,
    "xp": 992,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 265,
    "xp": 997,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 266,
    "xp": 1002,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 267,
    "xp": 1007,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 268,
    "xp": 1012,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 269,
    "xp": 1017,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 270,
    "xp": 1022,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 271,
    "xp": 1027,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 272,
    "xp": 1032,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 273,
    "xp": 1037,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 274,
    "xp": 1042,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 275,
    "xp": 1047,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 276,
    "xp": 1052,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 277,
    "xp": 1057,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 278,
    "xp": 1062,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 279,
    "xp": 1067,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 280,
    "xp": 1072,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 281,
    "xp": 1077,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 282,
    "xp": 1082,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 283,
    "xp": 1087,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 284,
    "xp": 1092,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 285,
    "xp": 1097,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 286,
    "xp": 1102,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 287,
    "xp": 1107,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 288,
    "xp": 1112,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 289,
    "xp": 1117,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 290,
    "xp": 1122,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 291,
    "xp": 1127,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 292,
    "xp": 1132,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 293,
    "xp": 1137,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 294,
    "xp": 1142,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 295,
    "xp": 1147,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 296,
    "xp": 1152,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 297,
    "xp": 1157,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 298,
    "xp": 1162,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 299,
    "xp": 1167,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 300,
    "xp": 1172,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 301,
    "xp": 1177,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 302,
    "xp": 1182,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 303,
    "xp": 1187,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 304,
    "xp": 1192,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 305,
    "xp": 1197,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 306,
    "xp": 1202,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 307,
    "xp": 1207,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 308,
    "xp": 1212,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 309,
    "xp": 1217,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 310,
    "xp": 1222,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 311,
    "xp": 1227,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 312,
    "xp": 1232,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 313,
    "xp": 1237,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 314,
    "xp": 1242,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 315,
    "xp": 1247,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 316,
    "xp": 1252,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 317,
    "xp": 1257,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 318,
    "xp": 1262,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 319,
    "xp": 1267,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 320,
    "xp": 1272,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 321,
    "xp": 1277,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 322,
    "xp": 1282,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 323,
    "xp": 1287,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 324,
    "xp": 1292,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 325,
    "xp": 1297,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 326,
    "xp": 1302,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 327,
    "xp": 1307,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 328,
    "xp": 1312,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 329,
    "xp": 1317,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 330,
    "xp": 1322,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 331,
    "xp": 1327,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 332,
    "xp": 1332,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 333,
    "xp": 1337,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 334,
    "xp": 1342,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 335,
    "xp": 1347,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 336,
    "xp": 1352,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 337,
    "xp": 1357,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 338,
    "xp": 1362,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 339,
    "xp": 1367,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 340,
    "xp": 1372,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 341,
    "xp": 1377,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 342,
    "xp": 1382,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 343,
    "xp": 1387,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 344,
    "xp": 1392,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 345,
    "xp": 1397,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 346,
    "xp": 1402,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 347,
    "xp": 1407,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 348,
    "xp": 1412,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 349,
    "xp": 1417,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 350,
    "xp": 1422,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 351,
    "xp": 1427,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 352,
    "xp": 1432,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 353,
    "xp": 1437,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 354,
    "xp": 1442,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 355,
    "xp": 1447,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 356,
    "xp": 1452,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 357,
    "xp": 1457,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 358,
    "xp": 1462,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 359,
    "xp": 1467,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 360,
    "xp": 1472,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 361,
    "xp": 1477,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 362,
    "xp": 1482,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 363,
    "xp": 1487,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 364,
    "xp": 1492,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 365,
    "xp": 1497,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 366,
    "xp": 1502,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 367,
    "xp": 1507,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 368,
    "xp": 1512,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 369,
    "xp": 1517,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 370,
    "xp": 1522,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 371,
    "xp": 1527,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 372,
    "xp": 1532,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 373,
    "xp": 1537,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 374,
    "xp": 1542,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 375,
    "xp": 1547,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 376,
    "xp": 1552,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 377,
    "xp": 1557,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 378,
    "xp": 1562,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 379,
    "xp": 1567,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 380,
    "xp": 1572,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 381,
    "xp": 1577,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 382,
    "xp": 1582,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 383,
    "xp": 1587,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 384,
    "xp": 1592,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 385,
    "xp": 1597,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 386,
    "xp": 1602,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 387,
    "xp": 1607,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 388,
    "xp": 1612,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 389,
    "xp": 1617,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 390,
    "xp": 1622,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 391,
    "xp": 1627,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 392,
    "xp": 1632,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 393,
    "xp": 1637,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 394,
    "xp": 1642,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 395,
    "xp": 1647,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 396,
    "xp": 1652,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 397,
    "xp": 1657,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 398,
    "xp": 1662,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 399,
    "xp": 1667,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 400,
    "xp": 1672,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 401,
    "xp": 1677,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 402,
    "xp": 1682,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 403,
    "xp": 1687,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 404,
    "xp": 1692,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 405,
    "xp": 1697,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 406,
    "xp": 1702,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 407,
    "xp": 1707,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 408,
    "xp": 1712,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 409,
    "xp": 1717,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 410,
    "xp": 1722,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 411,
    "xp": 1727,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 412,
    "xp": 1732,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 413,
    "xp": 1737,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 414,
    "xp": 1742,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 415,
    "xp": 1747,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 416,
    "xp": 1752,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 417,
    "xp": 1757,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 418,
    "xp": 1762,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 419,
    "xp": 1767,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 420,
    "xp": 1772,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 421,
    "xp": 1777,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 422,
    "xp": 1782,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 423,
    "xp": 1787,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 424,
    "xp": 1792,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 425,
    "xp": 1797,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 426,
    "xp": 1802,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 427,
    "xp": 1807,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 428,
    "xp": 1812,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 429,
    "xp": 1817,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 430,
    "xp": 1822,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 431,
    "xp": 1827,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 432,
    "xp": 1832,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 433,
    "xp": 1837,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 434,
    "xp": 1842,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 435,
    "xp": 1847,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 436,
    "xp": 1852,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 437,
    "xp": 1857,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 438,
    "xp": 1862,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 439,
    "xp": 1867,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 440,
    "xp": 1872,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 441,
    "xp": 1877,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 442,
    "xp": 1882,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 443,
    "xp": 1887,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 444,
    "xp": 1892,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 445,
    "xp": 1897,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 446,
    "xp": 1902,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 447,
    "xp": 1907,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 448,
    "xp": 1912,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 449,
    "xp": 1917,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 450,
    "xp": 1922,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 451,
    "xp": 1927,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 452,
    "xp": 1932,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 453,
    "xp": 1937,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 454,
    "xp": 1942,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 455,
    "xp": 1947,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 456,
    "xp": 1952,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 457,
    "xp": 1957,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 458,
    "xp": 1962,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 459,
    "xp": 1967,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 460,
    "xp": 1972,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 461,
    "xp": 1977,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 462,
    "xp": 1982,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 463,
    "xp": 1987,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 464,
    "xp": 1992,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 465,
    "xp": 1997,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 466,
    "xp": 2002,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 467,
    "xp": 2007,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 468,
    "xp": 2012,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 469,
    "xp": 2017,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 470,
    "xp": 2022,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 471,
    "xp": 2027,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 472,
    "xp": 2032,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 473,
    "xp": 2037,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 474,
    "xp": 2042,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 475,
    "xp": 2047,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 476,
    "xp": 2052,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 477,
    "xp": 2057,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 478,
    "xp": 2062,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 479,
    "xp": 2067,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 480,
    "xp": 2072,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 481,
    "xp": 2077,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 482,
    "xp": 2082,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 483,
    "xp": 2087,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 484,
    "xp": 2092,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 485,
    "xp": 2097,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 486,
    "xp": 2102,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 487,
    "xp": 2107,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 488,
    "xp": 2112,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 489,
    "xp": 2117,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 490,
    "xp": 2122,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 491,
    "xp": 2127,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 492,
    "xp": 2132,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 493,
    "xp": 2137,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 494,
    "xp": 2142,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 495,
    "xp": 2147,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 496,
    "xp": 2152,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 497,
    "xp": 2157,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 498,
    "xp": 2162,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 499,
    "xp": 2167,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 500,
    "xp": 2172,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 501,
    "xp": 2177,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 502,
    "xp": 2182,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 503,
    "xp": 2187,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 504,
    "xp": 2192,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 505,
    "xp": 2197,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 506,
    "xp": 2202,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 507,
    "xp": 2207,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 508,
    "xp": 2212,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 509,
    "xp": 2217,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 510,
    "xp": 2222,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 511,
    "xp": 2227,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 512,
    "xp": 2232,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 513,
    "xp": 2237,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 514,
    "xp": 2242,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 515,
    "xp": 2247,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 516,
    "xp": 2252,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 517,
    "xp": 2257,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 518,
    "xp": 2262,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 519,
    "xp": 2267,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 520,
    "xp": 2272,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 521,
    "xp": 2277,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 522,
    "xp": 2282,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 523,
    "xp": 2287,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 524,
    "xp": 2292,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 525,
    "xp": 2297,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 526,
    "xp": 2302,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 527,
    "xp": 2307,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 528,
    "xp": 2312,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 529,
    "xp": 2317,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 530,
    "xp": 2322,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 531,
    "xp": 2327,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 532,
    "xp": 2332,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 533,
    "xp": 2337,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 534,
    "xp": 2342,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 535,
    "xp": 2347,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 536,
    "xp": 2352,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 537,
    "xp": 2357,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 538,
    "xp": 2362,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 539,
    "xp": 2367,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 540,
    "xp": 2372,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 541,
    "xp": 2377,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 542,
    "xp": 2382,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 543,
    "xp": 2387,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 544,
    "xp": 2392,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 545,
    "xp": 2397,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 546,
    "xp": 2402,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 547,
    "xp": 2407,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 548,
    "xp": 2412,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 549,
    "xp": 2417,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 550,
    "xp": 2422,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 551,
    "xp": 2427,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 552,
    "xp": 2432,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 553,
    "xp": 2437,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 554,
    "xp": 2442,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 555,
    "xp": 2447,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 556,
    "xp": 2452,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 557,
    "xp": 2457,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 558,
    "xp": 2462,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 559,
    "xp": 2467,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 560,
    "xp": 2472,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 561,
    "xp": 2477,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 562,
    "xp": 2482,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 563,
    "xp": 2487,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 564,
    "xp": 2492,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 565,
    "xp": 2497,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 566,
    "xp": 2502,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 567,
    "xp": 2507,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 568,
    "xp": 2512,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 569,
    "xp": 2517,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 570,
    "xp": 2522,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 571,
    "xp": 2527,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 572,
    "xp": 2532,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 573,
    "xp": 2537,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 574,
    "xp": 2542,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 575,
    "xp": 2547,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 576,
    "xp": 2552,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 577,
    "xp": 2557,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 578,
    "xp": 2562,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 579,
    "xp": 2567,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 580,
    "xp": 2572,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 581,
    "xp": 2577,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 582,
    "xp": 2582,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 583,
    "xp": 2587,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 584,
    "xp": 2592,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 585,
    "xp": 2597,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 586,
    "xp": 2602,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 587,
    "xp": 2607,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 588,
    "xp": 2612,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 589,
    "xp": 2617,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 590,
    "xp": 2622,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 591,
    "xp": 2627,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 592,
    "xp": 2632,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 593,
    "xp": 2637,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 594,
    "xp": 2642,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 595,
    "xp": 2647,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 596,
    "xp": 2652,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 597,
    "xp": 2657,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 598,
    "xp": 2662,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 599,
    "xp": 2667,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 600,
    "xp": 2672,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 601,
    "xp": 2677,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 602,
    "xp": 2682,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 603,
    "xp": 2687,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 604,
    "xp": 2692,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 605,
    "xp": 2697,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 606,
    "xp": 2702,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 607,
    "xp": 2707,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 608,
    "xp": 2712,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 609,
    "xp": 2717,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 610,
    "xp": 2722,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 611,
    "xp": 2727,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 612,
    "xp": 2732,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 613,
    "xp": 2737,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 614,
    "xp": 2742,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 615,
    "xp": 2747,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 616,
    "xp": 2752,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 617,
    "xp": 2757,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 618,
    "xp": 2762,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 619,
    "xp": 2767,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 620,
    "xp": 2772,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 621,
    "xp": 2777,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 622,
    "xp": 2782,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 623,
    "xp": 2787,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 624,
    "xp": 2792,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 625,
    "xp": 2797,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 626,
    "xp": 2802,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 627,
    "xp": 2807,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 628,
    "xp": 2812,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 629,
    "xp": 2817,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 630,
    "xp": 2822,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 631,
    "xp": 2827,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 632,
    "xp": 2832,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 633,
    "xp": 2837,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 634,
    "xp": 2842,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 635,
    "xp": 2847,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 636,
    "xp": 2852,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 637,
    "xp": 2857,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 638,
    "xp": 2862,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 639,
    "xp": 2867,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 640,
    "xp": 2872,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 641,
    "xp": 2877,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 642,
    "xp": 2882,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 643,
    "xp": 2887,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 644,
    "xp": 2892,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 645,
    "xp": 2897,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 646,
    "xp": 2902,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 647,
    "xp": 2907,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 648,
    "xp": 2912,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 649,
    "xp": 2917,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 650,
    "xp": 2922,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 651,
    "xp": 2927,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 652,
    "xp": 2932,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 653,
    "xp": 2937,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 654,
    "xp": 2942,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 655,
    "xp": 2947,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 656,
    "xp": 2952,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 657,
    "xp": 2957,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 658,
    "xp": 2962,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 659,
    "xp": 2967,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 660,
    "xp": 2972,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 661,
    "xp": 2977,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 662,
    "xp": 2982,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 663,
    "xp": 2987,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 664,
    "xp": 2992,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 665,
    "xp": 2997,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 666,
    "xp": 3002,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 667,
    "xp": 3007,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 668,
    "xp": 3012,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 669,
    "xp": 3017,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 670,
    "xp": 3022,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 671,
    "xp": 3027,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 672,
    "xp": 3032,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 673,
    "xp": 3037,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 674,
    "xp": 3042,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 675,
    "xp": 3047,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 676,
    "xp": 3052,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 677,
    "xp": 3057,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 678,
    "xp": 3062,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 679,
    "xp": 3067,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 680,
    "xp": 3072,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 681,
    "xp": 3077,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 682,
    "xp": 3082,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 683,
    "xp": 3087,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 684,
    "xp": 3092,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 685,
    "xp": 3097,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 686,
    "xp": 3102,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 687,
    "xp": 3107,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 688,
    "xp": 3112,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 689,
    "xp": 3117,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 690,
    "xp": 3122,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 691,
    "xp": 3127,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 692,
    "xp": 3132,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 693,
    "xp": 3137,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 694,
    "xp": 3142,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 695,
    "xp": 3147,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 696,
    "xp": 3152,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 697,
    "xp": 3157,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 698,
    "xp": 3162,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 699,
    "xp": 3167,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 700,
    "xp": 3172,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 701,
    "xp": 3177,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 702,
    "xp": 3182,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 703,
    "xp": 3187,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 704,
    "xp": 3192,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 705,
    "xp": 3197,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 706,
    "xp": 3202,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 707,
    "xp": 3207,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 708,
    "xp": 3212,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 709,
    "xp": 3217,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 710,
    "xp": 3222,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 711,
    "xp": 3227,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 712,
    "xp": 3232,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 713,
    "xp": 3237,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 714,
    "xp": 3242,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 715,
    "xp": 3247,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 716,
    "xp": 3252,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 717,
    "xp": 3257,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 718,
    "xp": 3262,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 719,
    "xp": 3267,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 720,
    "xp": 3272,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 721,
    "xp": 3277,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 722,
    "xp": 3282,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 723,
    "xp": 3287,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 724,
    "xp": 3292,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 725,
    "xp": 3297,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 726,
    "xp": 3302,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 727,
    "xp": 3307,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 728,
    "xp": 3312,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 729,
    "xp": 3317,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 730,
    "xp": 3322,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 731,
    "xp": 3327,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 732,
    "xp": 3332,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 733,
    "xp": 3337,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 734,
    "xp": 3342,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 735,
    "xp": 3347,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 736,
    "xp": 3352,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 737,
    "xp": 3357,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 738,
    "xp": 3362,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 739,
    "xp": 3367,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 740,
    "xp": 3372,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 741,
    "xp": 3377,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 742,
    "xp": 3382,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 743,
    "xp": 3387,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 744,
    "xp": 3392,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 745,
    "xp": 3397,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 746,
    "xp": 3402,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 747,
    "xp": 3407,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 748,
    "xp": 3412,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 749,
    "xp": 3417,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 750,
    "xp": 3422,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 751,
    "xp": 3427,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 752,
    "xp": 3432,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 753,
    "xp": 3437,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 754,
    "xp": 3442,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 755,
    "xp": 3447,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 756,
    "xp": 3452,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 757,
    "xp": 3457,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 758,
    "xp": 3462,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 759,
    "xp": 3467,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 760,
    "xp": 3472,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 761,
    "xp": 3477,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 762,
    "xp": 3482,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 763,
    "xp": 3487,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 764,
    "xp": 3492,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 765,
    "xp": 3497,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 766,
    "xp": 3502,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 767,
    "xp": 3507,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 768,
    "xp": 3512,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 769,
    "xp": 3517,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 770,
    "xp": 3522,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 771,
    "xp": 3527,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 772,
    "xp": 3532,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 773,
    "xp": 3537,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 774,
    "xp": 3542,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 775,
    "xp": 3547,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 776,
    "xp": 3552,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 777,
    "xp": 3557,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 778,
    "xp": 3562,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 779,
    "xp": 3567,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 780,
    "xp": 3572,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 781,
    "xp": 3577,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 782,
    "xp": 3582,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 783,
    "xp": 3587,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 784,
    "xp": 3592,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 785,
    "xp": 3597,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 786,
    "xp": 3602,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 787,
    "xp": 3607,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 788,
    "xp": 3612,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 789,
    "xp": 3617,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 790,
    "xp": 3622,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 791,
    "xp": 3627,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 792,
    "xp": 3632,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 793,
    "xp": 3637,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 794,
    "xp": 3642,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 795,
    "xp": 3647,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 796,
    "xp": 3652,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 797,
    "xp": 3657,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 798,
    "xp": 3662,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 799,
    "xp": 3667,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 800,
    "xp": 3672,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 801,
    "xp": 3677,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 802,
    "xp": 3682,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 803,
    "xp": 3687,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 804,
    "xp": 3692,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 805,
    "xp": 3697,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 806,
    "xp": 3702,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 807,
    "xp": 3707,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 808,
    "xp": 3712,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 809,
    "xp": 3717,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 810,
    "xp": 3722,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 811,
    "xp": 3727,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 812,
    "xp": 3732,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 813,
    "xp": 3737,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 814,
    "xp": 3742,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 815,
    "xp": 3747,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 816,
    "xp": 3752,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 817,
    "xp": 3757,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 818,
    "xp": 3762,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 819,
    "xp": 3767,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 820,
    "xp": 3772,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 821,
    "xp": 3777,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 822,
    "xp": 3782,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 823,
    "xp": 3787,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 824,
    "xp": 3792,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 825,
    "xp": 3797,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 826,
    "xp": 3802,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 827,
    "xp": 3807,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 828,
    "xp": 3812,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 829,
    "xp": 3817,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 830,
    "xp": 3822,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 831,
    "xp": 3827,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 832,
    "xp": 3832,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 833,
    "xp": 3837,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 834,
    "xp": 3842,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 835,
    "xp": 3847,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 836,
    "xp": 3852,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 837,
    "xp": 3857,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 838,
    "xp": 3862,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 839,
    "xp": 3867,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 840,
    "xp": 3872,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 841,
    "xp": 3877,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 842,
    "xp": 3882,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 843,
    "xp": 3887,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 844,
    "xp": 3892,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 845,
    "xp": 3897,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 846,
    "xp": 3902,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 847,
    "xp": 3907,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 848,
    "xp": 3912,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 849,
    "xp": 3917,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 850,
    "xp": 3922,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 851,
    "xp": 3927,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 852,
    "xp": 3932,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 853,
    "xp": 3937,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 854,
    "xp": 3942,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 855,
    "xp": 3947,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 856,
    "xp": 3952,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 857,
    "xp": 3957,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 858,
    "xp": 3962,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 859,
    "xp": 3967,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 860,
    "xp": 3972,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 861,
    "xp": 3977,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 862,
    "xp": 3982,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 863,
    "xp": 3987,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 864,
    "xp": 3992,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 865,
    "xp": 3997,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 866,
    "xp": 4002,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 867,
    "xp": 4007,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 868,
    "xp": 4012,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 869,
    "xp": 4017,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 870,
    "xp": 4022,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 871,
    "xp": 4027,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 872,
    "xp": 4032,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 873,
    "xp": 4037,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 874,
    "xp": 4042,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 875,
    "xp": 4047,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 876,
    "xp": 4052,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 877,
    "xp": 4057,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 878,
    "xp": 4062,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 879,
    "xp": 4067,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 880,
    "xp": 4072,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 881,
    "xp": 4077,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 882,
    "xp": 4082,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 883,
    "xp": 4087,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 884,
    "xp": 4092,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 885,
    "xp": 4097,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 886,
    "xp": 4102,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 887,
    "xp": 4107,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 888,
    "xp": 4112,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 889,
    "xp": 4117,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 890,
    "xp": 4122,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 891,
    "xp": 4127,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 892,
    "xp": 4132,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 893,
    "xp": 4137,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 894,
    "xp": 4142,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 895,
    "xp": 4147,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 896,
    "xp": 4152,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 897,
    "xp": 4157,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 898,
    "xp": 4162,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 899,
    "xp": 4167,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 900,
    "xp": 4172,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 901,
    "xp": 4177,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 902,
    "xp": 4182,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 903,
    "xp": 4187,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 904,
    "xp": 4192,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 905,
    "xp": 4197,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 906,
    "xp": 4202,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 907,
    "xp": 4207,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 908,
    "xp": 4212,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 909,
    "xp": 4217,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 910,
    "xp": 4222,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 911,
    "xp": 4227,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 912,
    "xp": 4232,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 913,
    "xp": 4237,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 914,
    "xp": 4242,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 915,
    "xp": 4247,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 916,
    "xp": 4252,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 917,
    "xp": 4257,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 918,
    "xp": 4262,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 919,
    "xp": 4267,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 920,
    "xp": 4272,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 921,
    "xp": 4277,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 922,
    "xp": 4282,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 923,
    "xp": 4287,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 924,
    "xp": 4292,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 925,
    "xp": 4297,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 926,
    "xp": 4302,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 927,
    "xp": 4307,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 928,
    "xp": 4312,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 929,
    "xp": 4317,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 930,
    "xp": 4322,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 931,
    "xp": 4327,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 932,
    "xp": 4332,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 933,
    "xp": 4337,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 934,
    "xp": 4342,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 935,
    "xp": 4347,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 936,
    "xp": 4352,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 937,
    "xp": 4357,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 938,
    "xp": 4362,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 939,
    "xp": 4367,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 940,
    "xp": 4372,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 941,
    "xp": 4377,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 942,
    "xp": 4382,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 943,
    "xp": 4387,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 944,
    "xp": 4392,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 945,
    "xp": 4397,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 946,
    "xp": 4402,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 947,
    "xp": 4407,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 948,
    "xp": 4412,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 949,
    "xp": 4417,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 950,
    "xp": 4422,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 951,
    "xp": 4427,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 952,
    "xp": 4432,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 953,
    "xp": 4437,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 954,
    "xp": 4442,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 955,
    "xp": 4447,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 956,
    "xp": 4452,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 957,
    "xp": 4457,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 958,
    "xp": 4462,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 959,
    "xp": 4467,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 960,
    "xp": 4472,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 961,
    "xp": 4477,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 962,
    "xp": 4482,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 963,
    "xp": 4487,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 964,
    "xp": 4492,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 965,
    "xp": 4497,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 966,
    "xp": 4502,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 967,
    "xp": 4507,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 968,
    "xp": 4512,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 969,
    "xp": 4517,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 970,
    "xp": 4522,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 971,
    "xp": 4527,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 972,
    "xp": 4532,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 973,
    "xp": 4537,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 974,
    "xp": 4542,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 975,
    "xp": 4547,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 976,
    "xp": 4552,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 977,
    "xp": 4557,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 978,
    "xp": 4562,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 979,
    "xp": 4567,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 980,
    "xp": 4572,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 981,
    "xp": 4577,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 982,
    "xp": 4582,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 983,
    "xp": 4587,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 984,
    "xp": 4592,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 985,
    "xp": 4597,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 986,
    "xp": 4602,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 987,
    "xp": 4607,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 988,
    "xp": 4612,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 989,
    "xp": 4617,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 990,
    "xp": 4622,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 991,
    "xp": 4627,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 992,
    "xp": 4632,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 993,
    "xp": 4637,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 994,
    "xp": 4642,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 995,
    "xp": 4647,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 996,
    "xp": 4652,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 997,
    "xp": 4657,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 998,
    "xp": 4662,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  },
  {
    "level": 999,
    "xp": 4667,
    "reward_points": 1000,
    "energy_max_multiplier": 100
  }
]
